import { Tabs } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import SDoc from "../SDoc";
import { DocsEnum } from "@/types/doc";


interface TabsDocProps {
    docId: string;
    picDocId: string;
    isRead?: boolean;
    handleNewIds?: (id: string, type: DocsEnum) => void;
}



const TabsDoc = ({
    docId,
    picDocId,
    isRead = false,
    handleNewIds,
}: TabsDocProps) => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState<DocsEnum>(DocsEnum.PIC)
    const tabItems = [
        {
            key: DocsEnum.PIC,
            label: t("product.gallery"),
            children: <SDoc docId={picDocId} accept="image/*" isRead={isRead} handleNewDocId={id => handleNewIds && handleNewIds(id, DocsEnum.PIC)} />,
        },
        {
            key: DocsEnum.DOC,
            label: t("product.folder"),
            children: <SDoc docId={docId} isRead={isRead} handleNewDocId={id => handleNewIds && handleNewIds(id, DocsEnum.DOC)} />,
        },
    ]

    return (
        <Tabs
            activeKey={activeTab}
            onChange={(tab) => setActiveTab(tab as DocsEnum)}
            type="card"
            items={tabItems}
        />
    );
};

export default TabsDoc;
